import React, { FC, ReactElement } from 'react';
import MUICheckbox, { CheckboxProps } from '@mui/material/Checkbox';
import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';

import { CheckboxIcon, CheckOutlinedIcon } from 'src/shared/components/icons';

interface Props extends Omit<CheckboxProps, 'disabled' | 'onChange'> {
  label: string | number | ReactElement;
  checked?: boolean;
  disabled?: boolean;
  className?: string;
  onCheck?: () => void;
  _container?: FormControlLabelProps['sx'];
}

export const Checkbox: FC<Props> = ({ checked, disabled, label, className, onCheck, _container, ...props }) => {
  return (
    <FormControlLabel
      sx={_container}
      className={className}
      label={label}
      disabled={disabled}
      checked={checked}
      value={checked}
      onChange={onCheck}
      control={<MUICheckbox {...props} checkedIcon={<CheckboxIcon />} icon={<CheckOutlinedIcon />} size="small" />}
    />
  );
};
